<div class="home-page" [style.background-image]="!!background ? background : ''">

</div>
